module.exports = __webpack_public_path__ + "img/hr-tree-03-d-leaves.648cb7b2.png";